module.exports = __webpack_public_path__ + "static/media/anfora_royal_bird.dfa0a591.png";